import React from 'react';
import Modal from '@stencil/hotels-modal-component';

// components
import InfoModal from '../../../../verticals/hotels-mweb/src/shared/components/InfoModal/InfoModal';

import * as S from './Faqs.styles';

const customModalKey = 'seofaqsModal';

const FaqsModal = ({isPWA = false, heading = '', isOpen, closeModal, children}) => {
  if (isPWA) {
    return (
      <InfoModal
        isFullScreen={true}
        customModalKey={customModalKey}
        isModalOpen={isOpen}
        onModalChange={closeModal}
        header={heading}
        customContainerStyles={{
          contentWrapper: {
            borderRadius: '0px',
          },
        }}
      >
        <S.ModalPWAHeader>{children}</S.ModalPWAHeader>
      </InfoModal>
    );
  }
  return (
    <Modal isOpen={isOpen} closeModal={closeModal} modalStyles={{width: 'auto'}}>
      <S.ModalWrapper>{children}</S.ModalWrapper>
    </Modal>
  );
};

export default FaqsModal;
